module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-700.1a7ec31e.woff2";